var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 42,
  viewBox: "0 0 12 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.55838 11.3679V20.4873H3.87313V11.3679H0.8125V7.80755H3.87313V5.24662C3.87313 2.12352 5.68452 0.499516 8.43284 0.499516C9.35308 0.458384 10.275 0.521243 11.1812 0.686901V3.80999H9.30731C7.87069 3.80999 7.55838 4.49707 7.55838 5.55893V7.80755H11.1187L10.619 11.3679H7.55838Z",
  fill: "nofill"
})));
export default SvgFacebook;